import { Plus, Square } from "lucide-react";

export default function NoteForm({ newNote, setNewNote, onSubmit, skillSuggestions }) {
  return (
    <div className="border border-zinc-800 bg-[#0A0A0A] p-5 space-y-4">
      <div>
        <label className="font-label block mb-2">Title</label>
        <input
          data-testid="note-title-input"
          placeholder="ex: Half guard sweep details"
          value={newNote.title}
          onChange={(e) => setNewNote({ ...newNote, title: e.target.value })}
          className="w-full bg-[#141414] border border-zinc-800 px-4 py-3 text-sm focus:border-red-600 focus:outline-none"
        />
      </div>
      <div>
        <label className="font-label block mb-2">Skill Learned</label>
        <input
          data-testid="note-skill-input"
          placeholder="ex: Knee shield recovery"
          list="skill-suggestions"
          value={newNote.skill}
          onChange={(e) => setNewNote({ ...newNote, skill: e.target.value })}
          className="w-full bg-[#141414] border border-zinc-800 px-4 py-3 text-sm focus:border-red-600 focus:outline-none"
        />
        <datalist id="skill-suggestions">
          {skillSuggestions.map((name) => (
            <option key={name} value={name} />
          ))}
        </datalist>
      </div>
      <div>
        <label className="font-label block mb-2">Details</label>
        <textarea
          data-testid="note-details-input"
          placeholder="What did you learn today? What needs more reps?"
          value={newNote.details}
          onChange={(e) => setNewNote({ ...newNote, details: e.target.value })}
          className="w-full bg-[#141414] border border-zinc-800 px-4 py-3 text-sm min-h-[110px] focus:border-red-600 focus:outline-none resize-y"
        />
      </div>
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 pt-2">
        <div className="flex-1">
          <div className="flex items-center justify-between mb-2">
            <label className="font-label">Confidence</label>
            <div className="flex items-center gap-1.5" data-testid="rating-indicator">
              {[1, 2, 3, 4, 5].map((n) => (
                <Square
                  key={n}
                  className="w-3.5 h-3.5"
                  strokeWidth={2}
                  fill={n <= newNote.rating ? "#DC2626" : "transparent"}
                  color={n <= newNote.rating ? "#DC2626" : "#3F3F46"}
                />
              ))}
            </div>
          </div>
          <input
            type="range"
            min="1"
            max="5"
            value={newNote.rating}
            onChange={(e) => setNewNote({ ...newNote, rating: Number(e.target.value) })}
            className="w-full"
            data-testid="rating-slider"
          />
        </div>
        <button
          onClick={onSubmit}
          data-testid="add-note-button"
          className="bg-red-600 hover:bg-red-700 text-white font-heading tracking-wider px-6 py-3 flex items-center gap-2"
        >
          <Plus className="mr-2 h-4 w-4" strokeWidth={3} /> Log Entry
        </button>
      </div>
    </div>
  );
}
